export default "__VITE_ASSET__Cwv3uFYq__"